import { Link } from 'react-router';
import { LogoUCC } from './LogoUCC';

export function SiteFooter() {
  return (
    <footer className="border-t border-line bg-void">
      <div className="mx-auto grid max-w-ucc gap-10 px-6 py-14 sm:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <LogoUCC altura={28} />
            <span className="ucc-display text-lg tracking-wide">Ultimate Clubs Championship</span>
          </div>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-muted">
            Competição organizada, transparente e competitiva para a comunidade de
            EA SPORTS FC Clubs. PS5, Xbox Series X|S e PC.
          </p>
        </div>

        <nav aria-label="Competição">
          <h2 className="ucc-eyebrow">Competição</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/campeonatos" className="-my-1 block py-1.5 text-muted transition-colors hover:text-gold-ink">Campeonatos</Link></li>
            <li><Link to="/estatisticas" className="-my-1 block py-1.5 text-muted transition-colors hover:text-gold-ink">Estatísticas</Link></li>
            <li><Link to="/regulamento" className="-my-1 block py-1.5 text-muted transition-colors hover:text-gold-ink">Regulamento</Link></li>
          </ul>
        </nav>

        <nav aria-label="Organização">
          <h2 className="ucc-eyebrow">Organização</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/times" className="-my-1 block py-1.5 text-muted transition-colors hover:text-gold-ink">Times</Link></li>
            <li><Link to="/suporte" className="-my-1 block py-1.5 text-muted transition-colors hover:text-gold-ink">Abrir ticket</Link></li>
            <li><Link to="/entrar" className="-my-1 block py-1.5 text-muted transition-colors hover:text-gold-ink">Área do capitão</Link></li>
          </ul>
        </nav>
      </div>

      <div className="border-t border-line/60">
        <div className="mx-auto flex max-w-ucc flex-col gap-2 px-6 py-6 text-xs text-faint sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Ultimate Clubs Championship.</p>
          <p>
            Não afiliado à Electronic Arts. EA SPORTS FC é marca registrada da
            Electronic Arts Inc.
          </p>
        </div>
      </div>
    </footer>
  );
}
